import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Annotation } from '../models/Annotation';
import { PcsFilterCriteria, PendingIntegeration } from '../models/PendingIntegeration';
import { Print } from '../models/Print';
import { SearchInput } from '../models/SearchInput';
import { ShowSources } from '../models/ShowSources';
import { User } from '../../components/access-management/access-management.component';

@Injectable({
  providedIn: 'root'
})
export class CommonDataService {

  constructor() { }

  navData = new BehaviorSubject({
    crumbData : [],
    menuData : [],
  });
  resetPrintQueue = new BehaviorSubject<boolean>(true);
  showRightPanel = new BehaviorSubject<boolean>(false);
  rightPanelWidth = new BehaviorSubject<string>("");
  currentParagraph = new BehaviorSubject<string>("");
  currentParagraphId = new BehaviorSubject<string>("");
  rightOverlayOption = new BehaviorSubject<string>("");
  notificationObject = new BehaviorSubject({
    type : "",
    displayTime : 0,
    position : "",
    message:"",
  });
  annotationContent = new BehaviorSubject<Annotation>(null);
  acceptCookie = new BehaviorSubject<boolean>(false);
  pendingIntegeration = new BehaviorSubject<PendingIntegeration>(null);
  searchInput = new BehaviorSubject<SearchInput>(null);
  bookmarkId = new BehaviorSubject<string>("");
  deleteAnnotation = new BehaviorSubject<string>("");
  resetSourcesAndAnnotations = new BehaviorSubject<boolean>(null);
  letfNavData = new BehaviorSubject({});
  emailId = new BehaviorSubject<string>("");
  addAnnotationParagraphId = new BehaviorSubject<string>("");
  deleteAnnotationParagraphId = new BehaviorSubject<string>("");
  addBookmarkParagraphId = new BehaviorSubject<string>("");
  deleteBookmarkParagraphId = new BehaviorSubject<string>("");
  closeModalOption = new BehaviorSubject<boolean>(false);
  showActionButtoninTC = new BehaviorSubject<boolean>(false);
  showSecContent = new BehaviorSubject<boolean>(true);
  closeModalOptionofBasic = new BehaviorSubject<boolean>(false);
  showLoader = new BehaviorSubject<boolean>(false);
  isConfirmationPopUpOpen = new BehaviorSubject<boolean>(false);
  annotationWithinContent = new BehaviorSubject<string>("");
  printqueueCount = new BehaviorSubject<Print>(null);
  showSources = new BehaviorSubject<ShowSources>(null);
  displayAllSources = new BehaviorSubject<ShowSources>(null);
  displayAllSourcesToggleLabel = new BehaviorSubject<string>(null);
  displayAllSourcesForPrint = new BehaviorSubject<ShowSources>(null);
  myannotation = new BehaviorSubject<string>("");
  annotationUpdateSource = new BehaviorSubject<string>("");
  updateAnnotationParagraphId = new BehaviorSubject<string>("");
  displayallannotation = new BehaviorSubject<string>("");
  printCount = new BehaviorSubject<string>("");
  printwithannotations = new BehaviorSubject<string>("");
  printpreviewFileName = new BehaviorSubject<string>("");
  printToggleOff = new BehaviorSubject<string>("");
  tcsource = new BehaviorSubject<string>("");
  printContentHideShow = new BehaviorSubject<string>("");
 
  pendingcontentintegerationPage = new BehaviorSubject<boolean>(false);
  canactivate = new BehaviorSubject<boolean>(false);
  breadcrumbPath = new BehaviorSubject<string>("");
  TargetDivId = new BehaviorSubject<string>("");

  navDataContentPage = new BehaviorSubject([]);
  rightOverlayContentPageID = new BehaviorSubject({
    pubId:"",
    pageId:""
  });
  rightOverlayPendingContentData = new BehaviorSubject({
    pubId:"",
    pageId:"",
    paraId:""
  });
  crossreferencedParaID = new BehaviorSubject({
    paragraphID: "",
    standardType: "",
    standardNumber: "",
    paragraphNumber: ""
  });
  backbuttoncrossreference= new BehaviorSubject<boolean>(false);
  openSearchMenu = new BehaviorSubject<string>("");
  EditFromContentPage = new BehaviorSubject<boolean>(false);
  CrossRefReportNotGenerated=new BehaviorSubject<boolean>(true);
  aaaUserMessage =new BehaviorSubject<boolean>(false);
  NavigatingFromComponent=new BehaviorSubject<string>("");
  childComponent = new BehaviorSubject<boolean>(false);
  searchPageRefresh = new BehaviorSubject<string>("");
  searchContentLink=new BehaviorSubject<string>("");
  searchContentBreadCrumbPath=new BehaviorSubject<string>("");
  glossaryTermData=new BehaviorSubject<any>([]);
  userSession = new BehaviorSubject<any>([]);
  refreshValidation = new BehaviorSubject<boolean>(false);
  glossaryTermId = new BehaviorSubject<string>("");
  whatLinksHereParams = new BehaviorSubject<string>("");
  ASUParams = new BehaviorSubject<string>("");
  elasticSearchTopicData = new BehaviorSubject({});
  XBRLParams = new BehaviorSubject<string>("");
  removeAnnotationFromArray = new BehaviorSubject<string>("");
  glossaryFromCrossReference=new BehaviorSubject<boolean>(false);
  PCSFilterCriteria = new BehaviorSubject<PcsFilterCriteria>(null);
  archiveSecUrl = new BehaviorSubject<string>("");
  archiveNormalUrl = new BehaviorSubject<string>("");
  hasSecContent = new BehaviorSubject<boolean>(false);
  hasActualContent = new BehaviorSubject<boolean>(false);
  glossaryTerm = new BehaviorSubject<string>("");
  gotoUrl=new BehaviorSubject<string>("");
  glossaryTermTopicGlossaryTitle=new BehaviorSubject<string>("");
  glossaryTermBackButtonClicked = new BehaviorSubject<boolean>(false);
  glossaryTermFromContentPageBackButton = new BehaviorSubject<string>("");
  pageUrl = new BehaviorSubject<string>("");
  glossaryParentGuid = new BehaviorSubject([]);
  paraNumClicked = new BehaviorSubject<string>("");
  showAllPageUrlClicked = new BehaviorSubject<string>("");
  glossaryShowSource=new BehaviorSubject<boolean>(false);
  globalLabels = new BehaviorSubject<any>({});
  backToXBRLActive = new BehaviorSubject<boolean>(false);
  currentSortHeaderSTT = new BehaviorSubject<string>("");
  currentSortDirectionSTT = new BehaviorSubject<string>("");
  userData = new BehaviorSubject<User>(null);
  userAddedUpdated = new BehaviorSubject<boolean>(false);
  printTrigger = new BehaviorSubject<boolean>(false);
  invokedFromTOC = new BehaviorSubject<boolean>(false);
}
